import gql from 'graphql-tag';
import graphqlClient from '@shared/graphql/client';

export class GameService {
  static async updateCompetitionGame(id, data, subpropertyId) {
    if (!subpropertyId) return false;

    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation COMPETITION_GAME_UPDATE(
          $id: String!
          $data: CompetitionGameInput!
          $subpropertyId: String!
        ) {
          competitionGameUpdate(id: $id, data: $data, subpropertyId: $subpropertyId)
        }
      `,

      variables: {
        id,
        data,
        subpropertyId
      },
    });

    return response.data.competitionGameUpdate;
  }

  static async destroyAll(ids) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation GAME_DESTROY($ids: [String!]!) {
          gameDestroy(ids: $ids)
        }
      `,

      variables: {
        ids,
      },
    });

    return response.data.gameDestroy;
  }

  static async create(data) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation GAME_CREATE($data: GameInput!) {
          gameCreate(data: $data) {
            id
          }
        }
      `,

      variables: {
        data,
      },
    });

    return response.data.gameCreate;
  }

  static async import(values, importHash) {
    const response = await graphqlClient.mutate({
      mutation: gql`
        mutation GAME_IMPORT(
          $data: GameInput!
          $importHash: String!
        ) {
          gameImport(data: $data, importHash: $importHash)
        }
      `,

      variables: {
        data: values,
        importHash,
      },
    });

    return response.data.gameImport;
  }

  static async findCompetitionGameById(id, subpropertyId) {
    if ( !subpropertyId ) return { rows: [], count: 0 };
    const response = await graphqlClient.query({
      query: gql`
        query COMPETITION_GAME_FIND($id: String!, $subpropertyId: String! ) {
          competitionGameFind(id: $id, subpropertyId: $subpropertyId) {
            id
            homeTeamScore
            awayTeamScore
            awayTeam {
              id
              name
              logo {
                publicUrl
              }
              school {
                name
              }
              placeholderI18n
            }
            homeTeam {
              id
              name
              logo {
                publicUrl
              }
              school {
                name
              }
              placeholderI18n
            }
            timestamp
            isTimeAssigned
            location {
              name
              information
              url
              latitude
              longitude
            }
            regularSeasonRound {
              id
              startDate {
                year
                month
                day
              }
              endDate {
                year
                month
                day
              }
            }
            type
            status
            createdAt
            updatedAt
          }
        }
      `,

      variables: {
        id,
        subpropertyId
      },
    });

    return response.data.competitionGameFind;
  }

  static async competitionGameList(
    subpropertyId,
    filter,
    orderBy,
    limit,
    offset,
  ) {
    if (!subpropertyId) return { rows: [], count: 0 }
    const response = await graphqlClient.query({
      query: gql`
        query COMPETITION_GAME_LIST(
          $subpropertyId: String!
          $filter: GameFilterInput
          $orderBy: GameOrderByEnum
          $limit: Int
          $offset: Int
        ) {
          competitionGameList(
            subpropertyId: $subpropertyId
            filter: $filter
            orderBy: $orderBy
            limit: $limit
            offset: $offset
          ) {
            count
            rows {
              id
              homeTeamScore
              awayTeamScore
              homeTeam {
                name
                logo {
                  publicUrl
                  thumbPublicUrl
                }
                school {
                  name
                }
                placeholderI18n
              }
              awayTeam {
                name
                logo {
                  publicUrl
                  thumbPublicUrl
                }
                school {
                  name 
                }
                placeholderI18n
              }
              timestamp
              isTimeAssigned
              type
              playoff
              status
              location {
                name
                url
              }
              regularSeasonRound {
                id
                order
              }
            }
          }
        }
      `,

      variables: {
        subpropertyId,
        filter,
        orderBy,
        limit,
        offset,
      },
    });

    return response.data.competitionGameList;
  }

  static async listAutocomplete(query, limit) {
    const response = await graphqlClient.query({
      query: gql`
        query GAME_AUTOCOMPLETE(
          $query: String
          $limit: Int
        ) {
          gameAutocomplete(query: $query, limit: $limit) {
            id
            label
          }
        }
      `,

      variables: {
        query,
        limit,
      },
    });

    return response.data.gameAutocomplete;
  }
}
